import React from "react";
import Layouts from "../../helpers/Layouts";
import MainSection from "./MainSection";

export default function ServiceDetails() {
  return (
    <Layouts
      pageTitle="Services"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Services" },
      ]}
    >
      <MainSection />
    </Layouts>
  );
}
